import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import BasketProductList from './basketproductlist';
import PassengerDropdown from './components/passengerdropdown';
import Calender from './components/calender';



class BasketDetails extends PureComponent {


  render(){

    const { routeParams, product:{ header:{ passenger_types } }, currency, basketdetailsclass } = this.props;

    if(Object.keys(currency).length === 0) return <p>Loading...</p>

    return (
      <div className={`basketdetails ${basketdetailsclass}`}>

        <div className="trip-details-box">
          <div className="row">
            <div className="column small-12 large-4 col-left-mod-large">
              <PassengerDropdown passengerTypes={passenger_types} />
            </div>

            <div className="column small-12 large-8 col-right-mod-large">
              <BasketProductList routeParams={routeParams} />
            </div>
          </div>
        </div>

        <div className="calender-box ">
          <div className="row">
            <div className="column small-12">
              <Calender routeParams={routeParams} />
            </div>
          </div>
        </div>
    </div>
    )
  }
}

function mapStateToProps(state){
  return {
    currency:state.currency,
    product:state.product
  }
}

export default connect(mapStateToProps, null)(BasketDetails);



// WEBPACK FOOTER //
// ./src/components/basket/basketdetails.js